import axios from 'axios';

const api = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL || ''}/api/`,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

let refreshPromise = null;
const refreshAccessToken = () => {
  if (!refreshPromise) {
    const refresh = localStorage.getItem('refresh_token');
    refreshPromise = axios
      .post(`${process.env.REACT_APP_API_URL || ''}/api/token/refresh/`, { refresh })
      .then((res) => {
        localStorage.setItem('access_token', res.data.access);
        return res.data.access;
      })
      .finally(() => { refreshPromise = null; });
  }
  return refreshPromise;
};

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const { config, response } = error;
    if (response?.status === 401 && !config._retried && localStorage.getItem('refresh_token')) {
      config._retried = true;
      try {
        const newToken = await refreshAccessToken();
        config.headers.Authorization = `Bearer ${newToken}`;
        return api(config);
      } catch (refreshError) {
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        window.location.href = '/login';
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);

export default api;
